import React from 'react';
import './NotificationSkeleton.scss';

const NotificationSkeleton = () => {
  return (
    <div className="notification-skeleton notification">
      <div className="notification-skeleton__header spin" />
      <div className="notification-skeleton__info">
        <div className="notification-skeleton__info__title spin" />
        <div className="notification-skeleton__info__message spin" />
      </div>
    </div>
  );
};

export default NotificationSkeleton;
